import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
// Components
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";

// Constants
import { TITLE, SUB_TITLE, TRAINING_TYPE} from "./TechSalesTrainingConstants";
import { ALL_STEPS, CALENDAR_SUB_TITLE} from "./TechSalesTrainingConstants";
import { TITLE_ONE, TITLE_TWO, SUB_TITLE_ONE, SUB_TITLE_TWO, TITLE_NOTES, BODY_NOTES, TITLE_NOTES_1, BODY_NOTES_1} from "./TechSalesTrainingConstants";

// actions
import * as enablementAction from "../../../actions/partnerPortal/enablement/EnablementAction";

// Images
import salesBanner from '../../../assets/img/partnerPortal/sales/Half Wave.svg';

// Scss
import '../../../assets/css/partnerPortal/appDeveloper.scss';
import '../../../assets/css/partnerPortal/salesEnablement.scss';
import '../../../assets/css/partnerPortal/sales.scss';
import '../../../assets/css/partnerPortal/welcome.scss';
import '../../../assets/css/partnerPortal/calendar.scss';


import NewsSectionTwo from "../../../components/NewsSectionTwo";
import EventCLusterDTO from "../../../models/EventClusterDTO";
import Notes from "../../../components/Notes";
import CardWithNoBorder from "../../../components/CardWithNoBorder";
import Title from "../../../components/Title";

moment.locale("en-GB");
const localizer = momentLocalizer(moment);

function TechSalesTraining() {

  let history = useHistory();

  let [eventsData, setEventsData] = useState(Array<{title,start,end,link,region, type }>());



const onNavigate = useCallback((event) => ({
    ...(event.region === "EMEA" && {
        className: 'emea-color'
    }),
    ...(event.region === "NORAM" && {
        className: 'noram-color'
    }),
    ...(event.region === "LATAM" && {
        className: 'latam-color'
    }),
    ...(event.region === "APAC" && {
        className: 'apac-color'
    }),
    ...(event.type === "WEBINAR" && {
        className: 'live-webinar-color'
    })
    
    
}), []);
        

  useEffect(() => {
    canYouHaveAccess();
    getAllEventsByTraining();

  }, []);


  function openCalendarDay(e) {
    window.open(e.link, "_blank");
  }

  return (
    <>
        <div className="mb-3">
            <div className="d-flex flex-column align-items-center mb-3 w-100">
                <img src={salesBanner} className=' shadow-4 imageBannerSales' alt='...' />
                <div className="d-flex row w-100 marginsAssociate">
                    <div className="d-flex pt-4 flex-column align-items-center justify-content-center width42 mr-5">
                        <div className="d-flex align-items-start pb-4">
                            <Title classNameText="salesTitle" title={TITLE} withoutLine={true}/>
                        </div>
                        <div className="d-flex align-items-start">
                            <div className="subCopyLetters mb-3">
                                {SUB_TITLE}
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div className="containerAll">

                <div className="w-100 d-flex align-items-center flex-column mb-5">
                    <div className="FlexToBlock align-items-start w-100">
                        {ALL_STEPS.map(s => <CardWithNoBorder contentStart={true}  eyeBrow={s.step} title={s.title} subTitle={s.subTitle} /> )}
                    </div>
                </div>

                <div id="calendar" className="d-flex flex-column margin96Botton w-100 ">
                    <div className="d-flex flex-column align-items-center mb-5  ">
                        <div className="d-flex align-items-center align-self-stretch textStyle colorBlack m-auto">Join an upcoming session</div>
                    </div>
                    <div>
                        <div className="introframeSubText justify-content-center">
                        {CALENDAR_SUB_TITLE}
                        </div>
                        <div className="flexToBlockCard align-items-center w-100 mb-5">
                            
                            <div className="d-flex align-items-center flex-column width25 grow100">
                                <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                                        <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles emea-color p-2">
                                        EMEA timezones (CEST (UTC +2) / GMT)
                                        </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center flex-column width25 grow100">
                                <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                                        <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles noram-color p-2">
                                        NORAM timezones (ET (UTC -5) / CT)
                                        </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center flex-column width25 grow100">
                                <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                                        <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles latam-color p-2">
                                        LATAM timezones (EDT (UTC-4))
                                        </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center flex-column width25 grow100">
                                <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                                        <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles apac-color p-2">
                                        APAC timezones (SGT (UTC+8))
                                        </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <Calendar
                        views={["month"]}
                        selectable
                        localizer={localizer}
                        defaultDate={new Date()}
                        defaultView="month"
                        events={eventsData}
                        style={{ height: "100vh" }}
                        onSelectEvent={openCalendarDay}
                        eventPropGetter={onNavigate}
                    />
                </div>

                <div className="d-flex flex-column align-items-start width53 ml-auto mr-auto changeWidth">
                    <Notes title={TITLE_NOTES_1} body={BODY_NOTES_1}/>
                </div>

                <div className="d-flex flex-column align-items-start width53 margin96Top ml-auto mr-auto changeWidth">
                    <Notes title={TITLE_NOTES} body={BODY_NOTES}/>
                </div>

                <div className="faqTitle">
                    <div className="faqHeader">
                        <div className="faqTitleText">What else?</div>         
                    </div>
                </div>
       
                <NewsSectionTwo title={TITLE_ONE} subTitle={SUB_TITLE_ONE} />
                <NewsSectionTwo title={TITLE_TWO} subTitle={SUB_TITLE_TWO} />
             

            </div>

        </div >
    </>
  );



  async function getAllEventsByTraining() {
    
    enablementAction.getAllEventsByTraining(TRAINING_TYPE).then(response => {
        console.log(response.data);
        let events = Array<{title,start,end,link,region, type}>();
        const clusters: Array<EventCLusterDTO> = response.data;
        for (const c of clusters) {
            for (const e of c.events) {
                events.push({title: e.description, start: e.newDate, end: e.newDate, link: c.redirectUrl, region: e.type?.region, type: e.type?.name});
            }
        }
        setEventsData(events);
        return events;
    })
    .catch(err => {
        console.error('events were not catch. Error: ', err);
    });

  }


  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default TechSalesTraining;

